
import { MeService } from "@/api";
import {
    ME_FETCH,
    ME_POST,
    ME_RESET,
} from "@/store/actions.type";
import {
    FETCH_START,
    FETCH_END,
    SET_ME,
    POST_START,
    POST_END,
    POST_SET_ME,
    RESET_ME,
} from "@/store/mutations.type";

const state = () => ({
    isLoading: false,
    isSaving: false,
    me: {},
});

const actions = {

    async [ME_FETCH]({ commit, state }) {

        if (!!Object.keys(state.me).length) {
            return state.me;
        }

        commit(FETCH_START);

        try {
            const { data } = await MeService.get();
            commit(SET_ME, data);

            return data;

        } catch(e) {
            commit(FETCH_END);
        }

        return null;
    },

    async [ME_POST]({ commit, state}) {

        commit(POST_START);

        try {
            const { data } = await MeService.post({
                formData: { ...state.me },
                action: 'guestmanagement/participation/update-userdata'
            });
            commit(POST_SET_ME);

            return data;

        } catch(e) {
            commit(POST_END);
        }

        return null;
    },

    [ME_RESET]({ commit }) {

        commit(RESET_ME);

        return true;
    },
};

const mutations = {

    [FETCH_START](state) {
        state.isLoading = true;
    },

    [FETCH_END](state) {
        state.isLoading = false;
    },

    [SET_ME](state, data) {

        state.isLoading = false;
        state.me = {
            ...data
        };
    },

    [POST_START](state) {
        state.isSaving = true;
    },

    [POST_SET_ME](state) {
        state.isSaving = false;
    },

    [POST_END](state) {
        state.isSaving = false;
    },

    [RESET_ME](state) {

        state.isSaving = false;
        state.isLoading = false;
        state.me = {};
    },
};

const getters = {
    isLoading: (state) => {
        return state.isLoading;
    },

    isSaving: (state) => {
        return state.isSaving;
    },

    isKam: (state) => {
        return state.me.isKam;
    },

    hasKam: (state) => {
        return state.me.hasOwnProperty('participantKAM') && !!state.me.participantKAM.length;
    },

    getMe: (state) => {
        return state.me;
    },
};


export const me = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
